import { Props } from './LastConfigurationsDateFilter'
import { connect, MapStateToProps } from 'react-redux'
import lastConfigurationsAvailabilitiesSelector
    from '../../redux/selectors/garage/lastConfigurationsAvailabilitiesSelector'
import countrySelector from '../../redux/selectors/i18n/countrySelector'
import languageSelector from '../../redux/selectors/i18n/languageSelector'
import lastConfigurationsRequestIsPendingSelector
    from '../../redux/selectors/pending-request/lastConfigurationsRequestIsPendingSelector'

type StateProps = Pick<Props, 'lastConfigurationsAvailabilities' | 'country' | 'language' | 'isLoading'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    lastConfigurationsAvailabilities: lastConfigurationsAvailabilitiesSelector(state),
    country: countrySelector(state),
    language: languageSelector(state),
    isLoading: lastConfigurationsRequestIsPendingSelector(state),
})

export default connect(mapStateToProps)
